import dayjs from "dayjs";
import { DAYJS_FORMAT } from "./const";

const REMIND_DAYS = 31;

function updateData(dateStr: string) {
	const dayObj = dayjs(dateStr).subtract(REMIND_DAYS, "days");

	return dayObj.format(DAYJS_FORMAT);
}

export const CUSTOM_DATE_EVENTS: Array<{
	date: string;
	title: string;
}> = [{
	date: "2026-04-13",
	title: "Blokové čištění",
}, {
	date: "2026-06-24",
	title: "Blokové čištění",
}, {
	date: "2026-11-09",
	title: "Blokové čištění",
}, {
	date: "2026-05-27",
	title: "Blokové čištění PK",
}, {
	date: "2026-08-13",
	title: "Blokové čištění PK",
}, {
	date: updateData("2026-05-31"),
	title: "Odpady Brno",
}, {
	date: updateData("2026-03-28"),
	title: "Kia dálniční",
}, {
	date: updateData("2026-07-14"),
	title: "Rezidentní parkování",
}];
